import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import ArticleCard from "../components/ArticleCard";
import { fetchArticles } from "../api";

const SearchPage = () => {
  const params = new URLSearchParams(useLocation().search);
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticles({ q })
      .then(setResults)
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 fade-in">
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-sq-orange">Home</Link>
        <span>/</span>
        <span className="text-sq-navy font-medium">Ricerca</span>
      </div>
      <h1 className="font-serif-display text-3xl text-sq-navy mb-1">Risultati per: “{q}”</h1>
      <p className="text-gray-500 mb-8">
        {loading ? "Ricerca in corso..." : `${results.length} risultati trovati`}
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          {!loading && results.length === 0 ? (
            <p className="text-gray-500">Nessun risultato. Prova con altri termini.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {results.map((a) => (
                <ArticleCard key={a.id} article={a} />
              ))}
            </div>
          )}
        </div>
        <Sidebar />
      </div>
    </div>
  );
};

export default SearchPage;
